import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { filterFieldsForItemList, filterSystemCreatedFieldsForItemList } from 'drapcode-constant';
import * as actions from './redux/actions';
import CustomLoader from '../common/CustomLoader';
import ItemForm from './item/ItemForm';
import ItemTableRow from './item/itemTable/ItemTableRow';
import ItemListHeading from './item/itemTable/ItemListHeading';
import { drapcodeIcon } from '../../common/custom/icon-library';
import ParentDocCard from '../common/ParentDocCard';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import { filterUserCreatedFieldsForItemList } from '../common/FieldTypes';
import { prepS3Url } from '../../common/utils/plugin_utils';

export class AddItemInCollection extends Component {
  static propTypes = {
    collections: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  componentDidMount() {
    const { match, actions } = this.props;
    const { projectId, collectionId, version } = match.params;
    actions.loadProjectCollectionDetail({ projectId, collectionId, version });
  }

  showItemTable = () => {
    const { collections, actions, match, home, common } = this.props;
    const { projectId, collectionId, version } = match.params;
    const { selectedCollection, items } = collections;
    console.log('🚀 ~ file: AddItemInCollection.js:32 ~ AddItemInCollection ~ items:', items);
    if (!selectedCollection) {
      return;
    }
    let { fields, collectionTitle } = selectedCollection;
    fields = filterFieldsForItemList(fields);
    let systemCreatedFields = filterSystemCreatedFieldsForItemList(fields);
    let userCreatedFields = filterUserCreatedFieldsForItemList(fields);
    let userAndSystemCreatedFields = [...userCreatedFields, ...systemCreatedFields];
    const s3Url = prepS3Url(home.iPlugins, common.projectDetail, false);
    return (
      <>
        {items.length > 0 ? (
          <div className="table-responsive">
            <table className="table table-bordered table-sm table-word-break">
              <thead>
                <tr>
                  {userAndSystemCreatedFields.map((field, i) => (
                    <ItemListHeading field={field} key={i} />
                  ))}
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {items.length > 0 ? (
                  items.map((item, i) => (
                    <ItemTableRow
                      key={i}
                      item={item}
                      fields={userAndSystemCreatedFields}
                      actions={actions}
                      selectedCollection={selectedCollection}
                      projectId={projectId}
                      version={version}
                      iPlugins={home.iPlugins}
                      s3Url={s3Url}
                      projectDetail={common.projectDetail}
                    />
                  ))
                ) : (
                  <tr></tr>
                )}
              </tbody>
            </table>
          </div>
        ) : (
          <div>
            <h5 className="text-center">No Data!</h5>
          </div>
        )}
      </>
    );
  };

  showGotoAction = () => {
    const { collections, actions, match } = this.props;
    const { projectId, collectionId, version } = match.params;
    const { selectedCollection, items } = collections;
    if (!selectedCollection) {
      return;
    }

    const { collectionName, uuid } = selectedCollection;
    return (
      <>
        {selectedCollection && (
          <div className="row mx-auto">
            <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
              <div className="row">
                <div className="col-md-6 col-lg-6 col-sm-12 col-xs-12"></div>
                <div className="col-md-6 col-lg-6 col-sm-12 col-xs-12 pt-4 text-right">
                  <Link
                    className="btn btn-primary btn-md"
                    to={`/collections/${version}/v/${projectId}/items/${uuid}/name/${collectionName}`}
                    title="Goto Collection Data List"
                  >
                    <i className="wb webconnect-skip-forward-fill"></i> Goto Collection Data List
                  </Link>
                </div>
              </div>
            </div>
          </div>
        )}
      </>
    );
  };

  render() {
    const { collections, match, actions, home, common } = this.props;
    const { loadProjectCollectionDetailPending, selectedCollection, saveCollectionItemPending } =
      collections;
    const { collectionTitle } = selectedCollection || '';
    const { projectId, collectionId, version } = match.params;
    //TODO: Duplicate Code
    return (
      <CommonPageComponent parentClassName="">
        <div className="row mx-auto">
          <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
            {loadProjectCollectionDetailPending && (
              <div className="text-center">
                <CustomLoader
                  loading={loadProjectCollectionDetailPending}
                  size="20px"
                  color="#303453"
                />
              </div>
            )}

            <div className="row mx-auto">
              <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
                <div className="card">
                  <div
                    className="card-header card-header-icon"
                    data-background-color="drapcode-dark-blue"
                  >
                    <i className={`wb ${drapcodeIcon('form')}`}></i>
                  </div>

                  <div className="card-title-header pt-3">
                    <div className="row mx-auto">
                      <div className="col-3">
                        <h5 className="card-title">
                          {!loadProjectCollectionDetailPending && collectionTitle
                            ? `Add New Data in ${collectionTitle}`
                            : 'Add New Data in '}
                        </h5>
                      </div>
                      <div className="col-3 mt-2"></div>
                      <div className="col-3 mt-2"></div>
                      <div className="col-3 mt-2"></div>
                    </div>
                  </div>

                  <div className="card-content">
                    {selectedCollection && (
                      <ItemForm
                        projectId={projectId}
                        version={version}
                        collection={selectedCollection}
                        actions={actions}
                        collections={collections}
                        projectDetail={collections.projectDetail}
                        item={null}
                        isShowDeleteLoader={false}
                        isShowCreateOrUpdateLoader={saveCollectionItemPending}
                        isNotRedirect={true}
                        headerSmall={true}
                        isAddItemsPage={true}
                        home={home}
                        common={common}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
              <div className="card">
                <div
                  className="card-header card-header-icon"
                  data-background-color="drapcode-dark-blue"
                >
                  <i className={`wb ${drapcodeIcon('list')}`}></i>
                </div>
                <div className="card-content">
                  <h5 className="card-title">Collection Data</h5>
                  {this.showItemTable()}
                </div>
              </div>
            </div>
            {this.showGotoAction()}
          </div>
          <ParentDocCard>
            <h5>
              <b>About Collection Data</b>
            </h5>
            <p>
              After creating the structure of a collection, you can either add, update or delete
              data manually or bring or edit it dynamically using the events like Save Data, Update
              Data & Delete Data. Data can also be transferred from other databases using data
              sources like Airtable, Firestore, MongoDB, Google Sheet, Firebase Realtime Database &
              REST API.
            </p>
            <br />
          </ParentDocCard>
        </div>
      </CommonPageComponent>
    );
  }
}

function mapStateToProps(state) {
  return {
    collections: state.collections,
    home: state.home,
    common: state.common,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AddItemInCollection);
